import { render } from "./AllCategories.vue?vue&type=template&id=0ea99689&scoped=true"
import script from "./AllCategories.vue?vue&type=script&lang=js"
export * from "./AllCategories.vue?vue&type=script&lang=js"

import "./AllCategories.vue?vue&type=style&index=0&id=0ea99689&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ea99689"]])

export default __exports__